import Layout from '@/layout'

const InformationRouter = {
  path: '/Information',
  component: Layout,
  redirect: 'noredirect',
  name: 'Information',
  meta: {
    title: 'baseInfo',
    icon: 'daohang-ziliaoguanli',
    roles: []
  },
  children: [
    {
      path: 'SeaPort',
      component: () => import('@/views/cargo/v0/Information/seaPort'),
      name: 'SeaPort',
      meta: { title: 'seaport' },
      roles: ['module_SMSeaPort']
    },
    {
      path: 'AirPort',
      component: () => import('@/views/cargo/v0/Information/airPort'),
      name: 'AirPort',
      meta: { title: 'airport' },
      roles: ['module_SMAirPort']
    },
    {
      path: 'AirlineCode',
      component: () => import('@/views/cargo/v0/Information/airlineCode'),
      name: 'AirlineCode',
      meta: { title: 'airlineCode' },
      roles: ['module_AirlineCode']
    },
    {
      path: 'shippingCompany',
      component: () => import('@/views/cargo/v0/Information/shippingCompany'),
      name: 'shippingCompany',
      meta: { title: 'shippingCompany' },
      roles: ['module_shippingCompany']
    },
    {
      path: 'City',
      component: () => import('@/views/cargo/v0/Information/city'),
      name: 'City',
      meta: { title: 'city' },
      roles: ['module_SMCity']
    },
    {
      path: 'BasicData',
      component: () => import('@/views/cargo/v0/Information/basicData'),
      name: 'BasicData',
      meta: { title: 'basicData' },
      roles: ['module_MTBasicData']
    },
    {
      path: 'Operation',
      component: () => import('@/views/cargo/v0/Information/operation'),
      name: 'Operation',
      meta: { title: 'operationRequirementDescribe' },
      roles: ['module_fmOperationRequire']
    },
    {
      path: 'CustomsCommodityCode',
      component: () => import('@/views/cargo/v0/Information/customsCommodityCode'),
      name: 'CustomsCommodityCode',
      meta: { title: 'customsCommodityCode' },
      roles: ['module_HsCodeModule']
    },
    {
      path: 'USCommodityCode',
      component: () => import('@/views/cargo/v0/Information/usCommodityCode'),
      name: 'USCommodityCode',
      meta: { title: 'usCommodityCode' },
      roles: ['module_USCommodityCodeModule']
    },
    {
      path: 'Country',
      component: () => import('@/views/cargo/v0/Information/country'),
      name: 'Country',
      meta: { title: 'country' },
      roles: ['module_SMCountry']
    },
    {
      path: 'RateManagement',
      component: () => import('@/views/cargo/v0/Information/rateManagement'),
      name: 'RateManagement',
      meta: { title: 'rateManagement' },
      roles: ['module_SMRate']
    },
    {
      path: 'PayService',
      component: () => import('@/views/cargo/v0/Information/payService'),
      name: 'PayService',
      meta: { title: 'payService' },
      roles: ['module_SMChargeItem']
    },
    {
      path: 'CostPlan',
      component: () => import('@/views/cargo/v0/Information/costPlan'),
      name: 'CostPlan',
      meta: { title: 'costPlan' },
      roles: ['module_FMChargeScheme']
    },
    {
      path: 'Guarantee',
      component: () => import('@/views/cargo/v0/Information/guarantee'),
      name: 'Guarantee',
      meta: { title: 'guarantee' },
      roles: ['module_FMGuarantee']
    },
    {
      path: 'Partner/All',
      component: () => import('@/views/cargo/v0/Information/partner'),
      name: 'Partner',
      meta: { title: 'partner' },
      roles: ['module_SMPartner']
    },
    {
      path: 'Partner/Customs',
      component: () => import('@/views/cargo/v0/Information/partner'),
      name: 'Customs',
      meta: { title: '报关' },
      roles: ['module_fmCustomsPartners']
    },
    {
      path: 'Partner/Customer',
      component: () => import('@/views/cargo/v0/Information/partner'),
      name: 'Customer',
      meta: { title: '客户' },
      roles: ['module_fmCustomerPartners']
    },
    {
      path: 'Partner/Truck',
      component: () => import('@/views/cargo/v0/Information/partner'),
      name: 'Truck',
      meta: { title: '运输' },
      roles: ['module_fmCarryingPartners']
    },
    {
      path: 'Partner/Warehouse',
      component: () => import('@/views/cargo/v0/Information/partner'),
      name: 'Warehouse',
      meta: { title: '仓储' },
      roles: ['module_fmWarehousingPartners']
    },
    {
      path: 'Partner/Booking',
      component: () => import('@/views/cargo/v0/Information/partner'),
      name: 'Booking',
      meta: { title: '订舱代理' },
      roles: ['module_fmBookingPartners']
    },
    {
      path: 'Partner/Shipping',
      component: () => import('@/views/cargo/v0/Information/partner'),
      name: 'Shipping',
      meta: { title: '船公司' },
      roles: ['module_fmShipping']
    },
    {
      path: 'Partner/Airline',
      component: () => import('@/views/cargo/v0/Information/partner'),
      name: 'Airline',
      meta: { title: '航空公司' },
      roles: ['module_fmAirline']
    },
    {
      path: 'Partner/Agent',
      component: () => import('@/views/cargo/v0/Information/partner'),
      name: 'Agent',
      meta: { title: '海外代理' },
      roles: ['module_fmAgentPartners']
    },
    {
      path: 'Partner/Other',
      component: () => import('@/views/cargo/v0/Information/partner'),
      name: 'Other',
      meta: { title: '其他' },
      roles: ['module_fmOtherPartners']
    },
    {
      path: 'Partner/Factory_Sign',
      component: () => import('@/views/cargo/v0/Information/partner'),
      name: 'FactorySign',
      meta: { title: '工厂/生产商' },
      roles: ['module_fmFactoryPartners']
    },
    {
      path: 'MailingAddress',
      component: () => import('@/views/cargo/v0/Information/mailingAddress'),
      name: 'MailingAddress',
      meta: { title: 'mailingAddress' },
      roles: ['module_SMBillAddress']
    },
    {
      path: 'SeaPortRequirement',
      component: () => import('@/views/cargo/v0/Information/seaPortRequirement'),
      name: 'SeaPortRequirement',
      meta: { title: 'seaPortRequirement' },
      roles: ['module_SMSeaPortRequirement']
    },
    {
      path: 'AirPortRequirement',
      component: () => import('@/views/cargo/v0/Information/airPortRequirement'),
      name: 'AirPortRequirement',
      meta: { title: 'airPortRequirement' },
      roles: ['module_SMAirPortRequirement']
    },
    {
      path: 'PartnerInformationImport',
      component: () => import('@/views/cargo/v0/Information/partnerInformationImport'),
      name: 'PartnerInformationImport',
      meta: { title: 'partnerInformationImport' },
      roles: ['module_PartnerInformationImport']
    },
    {
      path: 'ContractManagement',
      component: () => import('@/views/cargo/v0/Information/ContractManagement/index'),
      name: 'ContractManagement',
      meta: { title: '合同管理' },
      roles: ['module_ContractManagement']
    },
    {
      path: 'RailwayStation',
      component: () => import('@/views/cargo/v0/Information/railwayStation'),
      name: 'RailwayStation',
      meta: { title: '铁路站点' },
      roles: []
    },
    {
      path: 'FMMSCHistoryBillAddress',
      component: () => import('@/views/cargo/v0/Information/fmMSCHistoryBillAddress'),
      name: 'FMMSCHistoryBillAddress',
      meta: { title: 'MSC提单地址' },
      roles: []
    },
    {
      path: 'ImportingTemplate',
      component: () => import('@/views/cargo/v0/Information/ImportingTemplate'),
      name: 'ImportingTemplate',
      meta: { title: '导入模板方案' },
      roles: ['module_ImportTemplate']
    },
    {
      path: 'SMDangerousGoods',
      component: () => import('@/views/cargo/v0/Information/smDangerousGoods'),
      name: 'SMDangerousGoods',
      meta: { title: '危险品清单' },
      roles: []
    },
    {
      path: 'SensitiveWord',
      component: () => import('@/views/cargo/v0/Information/sensitiveWord'),
      name: 'SensitiveWord',
      meta: { title: '敏感词管理' },
      roles: []
    },
    {
      path: 'AccountingMonth',
      component: () => import('@/views/cargo/v0/Information/AccountingMonth/index'),
      name: 'AccountingMonth',
      meta: { title: '财务月管理' },
      roles: []
    },
    {
      path: 'MailGroup',
      component: () => import('@/views/cargo/v0/Information/mailGroup'),
      name: 'MailGroup',
      meta: { title: '邮件群组' },
      roles: []
    },
    {
      path: 'OverseaWarehouse',
      component: () => import('@/views/cargo/v0/Information/overseaWarehouse'),
      name: 'OverseaWarehouse',
      meta: { title: '海外仓' },
      roles: ['module_SMOverseaWarehouse']
    },
    {
      path: 'RouteWarehouseConfiguration',
      component: () => import('@/views/cargo/v0/Information/routeWarehouseConfiguration'),
      name: 'RouteWarehouseConfiguration',
      meta: { title: '航线/港口预设配置' },
      roles: ['module_RouteWarehouseConfiguration']
    },
    {
      path: 'InnerContractNo',
      component: () => import('@/views/cargo/v0/Information/innerContractNo'),
      name: 'InnerContractNo',
      meta: { title: '内部约号管理' },
      roles: ['module_InnerContractNo']
    },
    {
      path: 'BondManagement',
      component: () => import('@/views/cargo/v0/Information/BondManagement'),
      name: 'BondManagement',
      meta: { title: 'Bond管理' },
      roles: ['module_SMBondManagement']
    }
  ]
}

export default InformationRouter
